// extracted by mini-css-extract-plugin
module.exports = {"nft-collection__container":"NftCollection_nft-collection__container__uE8AB"};